import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";

const GetShiftByIdApiImpl = async (id: string): Promise<Either<ErrorEntity, ShiftEntity>> => {
    try {
        const relativeUrl: string = `/shift/${id}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = ShiftDto.fromJSON(response.data || response);
        return right(parsed)
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default GetShiftByIdApiImpl;